import { createServerFn } from "@tanstack/react-start"
import { createClient } from "@supabase/supabase-js"
import { latestSurprise, type ReleaseRow, type SurpriseDTO } from "@/lib/macro-surprise"

let cache: { at: number; data: SurpriseDTO } | null = null
export const getMacroSurprises = createServerFn({ method: "GET" }).handler(async (): Promise<SurpriseDTO> => {
  if (cache && Date.now() - cache.at < 15 * 60_000) return cache.data
  try {
    const key = process.env["SUPABASE_PUBLISHABLE_KEY"]
    const url = process.env["SUPABASE_URL"]
    if (!key || !url) return { cpi: null, nfp: null }
    const db = createClient(url, key, {
      auth: { persistSession: false },
      global: { fetch: (input, init) => {
        const headers = new Headers(init?.headers)
        if (key.startsWith("sb_") && headers.get("Authorization") === `Bearer ${key}`) headers.delete("Authorization")
        headers.set("apikey", key)
        return fetch(input, { ...init, headers })
      } },
    })
    const { data, error } = await db.from("economic_calendar_actuals")
      .select("event_date,title,actual,forecast,source")
      .in("title", ["CPI y/y", "Non-Farm Employment Change", "cpi y y", "non farm employment change"])
      .gte("event_date", new Date(Date.now() - 45 * 864e5).toISOString())
      .lte("event_date", new Date().toISOString()).order("event_date", { ascending: false }).limit(12)
    if (error) throw error
    const rows = (data ?? []) as ReleaseRow[]
    const result = { cpi: latestSurprise(rows, "cpi"), nfp: latestSurprise(rows, "nfp") }
    cache = { at: Date.now(), data: result }
    return result
  } catch (e) {
    console.warn("[macro-surprise] unavailable", e)
    return { cpi: null, nfp: null }
  }
})